export { default as LoginPage } from './LoginPage.vue'
